import axios from "axios";

import { baseApiUrl } from "../common/constants";
import { handleError, handleSuccess } from "./handlers";

const baseUrl = `${baseApiUrl}/trash`;

export const getAllTrash = async (onSuccess, onError) => {
  axios
    .get(`${baseUrl}/`)
    .then((response) => handleSuccess(response, onSuccess))
    .catch((error) => handleError(error, onError));
};

export const archiveIdeas = async (params, onSuccess, onError) => {
  axios
    .post(`${baseUrl}/archive/ideas`, params)
    .then((response) => handleSuccess(response, onSuccess))
    .catch((error) => handleError(error, onError));
};

export const restoreIdeas = async (params, onSuccess, onError) => {
  try {
    const response = await axios.post(`${baseUrl}/restore/ideas`, params);

    return handleSuccess(response, onSuccess);
  } catch (error) {
    throw handleError(error, onError);
  }
};

export const archiveAttributes = async (params, onSuccess, onError) => {
  axios
    .post(`${baseUrl}/archive/attributes`, params)
    .then((response) => handleSuccess(response, onSuccess))
    .catch((error) => handleError(error, onError));
};

export const restoreAttributes = async (params, onSuccess, onError) => {
  try {
    const response = await axios.post(`${baseUrl}/restore/attributes`, params);

    return handleSuccess(response, onSuccess);
  } catch (error) {
    throw handleError(error, onError);
  }
};

export const archiveComponents = async (params, onSuccess, onError) => {
  axios
    .post(`${baseUrl}/archive/components`, params)
    .then((response) => handleSuccess(response, onSuccess))
    .catch((error) => handleError(error, onError));
};

export const restoreComponents = async (params, onSuccess, onError) => {
  try {
    const response = await axios.post(`${baseUrl}/restore/components`, params);

    return handleSuccess(response, onSuccess);
  } catch (error) {
    throw handleError(error, onError);
  }
};

export const archiveProjects = async (params, onSuccess, onError) => {
  axios
    .post(`${baseUrl}/archive/projects`, params)
    .then((response) => handleSuccess(response, onSuccess))
    .catch((error) => handleError(error, onError));
};

export const restoreProjects = async (params, onSuccess, onError) => {
  try {
    const response = await axios.post(`${baseUrl}/restore/projects`, params);

    return handleSuccess(response, onSuccess);
  } catch (error) {
    throw handleError(error, onError);
  }
};
